import React from "react"
import  MainCP from "../../Components/apruebo-rechazo/MainCP"

const ViewAprueboRechazo: React.FC = () => <MainCP/>
export default ViewAprueboRechazo;